<div class="content" *ngIf="manifest" style="padding: 5px; font-size: 16px">
  <div class="row">
    <div class="col-md-8">
      <div class="help-block h4 Allheaders">
        Manifest Detail {{ manifest.shipped ? "(Shipped)" : "" }}
        <close-button></close-button>
        <button
          title="Download Report"
          type="button"
          (click)="downloadReport(manifest.trackingNumber)"
          class="btn btn-outline-secondary pull-right"
        >
          <mat-icon>file_download</mat-icon>
        </button>
        <button
          *ngIf="manifest.canPrint"
          type="button"
          class="btn btn-outline-secondary pull-right"
          tooltip="Print Manifest"
          (click)="downloadPrint(manifest.trackingNumber)"
        >
          <mat-icon>print</mat-icon>
        </button>
      </div>
      <hr />
    </div>
  </div>

  <div class="card" title="Item Detail">
    <div class="card-body">
      <div id="printme">
        <div class="row">
          <div class="col-md-12">
            <br />
            <div class="panel" [ngClass]="'panel-' + manifest.style">
              <div class="panel-body" id="component1">
                <div class="row">
                  <div class="col-md-2">
                    <dt class="Allheaders">Waste Type:</dt>
                    <dd class="Allheaders" id="generatorId">{{manifest.wasteType}}</dd>
                  </div>
                  <div class="col-md-2">
                    <dt class="Allheaders">Generator ID</dt>
                    <dd class="h12pt" id="generatorId">{{manifest.generatorId }}</dd>
                  </div>
                  <div class="col-md-2">
                    <dt class="Allheaders">Pages</dt>
                    <dd class="h12pt" id="pageNumber">{{ manifest.totalPages }}</dd>
                  </div>
                  <div class="col-md-2">
                    <dt class="Allheaders">Emergency Phone</dt>
                    <dd class="h12pt" id="emergencyPhone">{{ manifest.emergencyPhone}}</dd>
                  </div>

                  <div class="col-md-2">
                    <dt class="Allheaders">Tracking No.</dt>
                    <dd class="Allheaders">{{manifest.trackingNumber}}</dd>
                  </div>
                  <div class="col-md-1">
                    <dt class="Allheaders">Ship Date</dt>
                    <dd class="Allheaders">{{manifest.shippingDate | date:' MM / dd / yyyy' }}</dd>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <dt class="Allheaders">Generators Name and Mailing Address</dt>
                    <dd style="display: inline-block">
                      <div class="h11pt" id="generatorNameCompany">
                        {{manifest.generatorCompany}}
                      </div>
                      <div class="h11pt" id="generatorAddress">
                        {{manifest.generatorMailingAddress}}
                      </div>
                    </dd>
                  </div>
                  <div class="col-md-6">
                    <dt class="Allheaders">Generators Site Address</dt>
                    <dd>{{manifest.generatorSiteAddress}}</dd>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6" style="display: inline-block">
                    <strong class="Allheaders">Generator's Phone: </strong>
                    <span class="h11pt" id="Phone">{{manifest.generatorPhone}} ATTN:</span>
                    <span class="h11pt" id="generatorName"> {{manifest.generatorName}}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <dt class="Allheaders">Transport 1 Company Name</dt>
                    <dd class="h2" id="TransporterCompany1">{{manifest.transporter1Company}}</dd>
                  </div>
                  <div class="col-md-6">
                    <dt class="Allheaders">US EPA ID Number</dt>
                    <dd class="h11pt" id="USEpaIDNumberTransporter1">
                      {{manifest.transporter1Epaid}}
                    </dd>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <dt class="Allheaders">Transport 2 Company Name</dt>
                    <dd class="h2" id="TransporterCompany2">{{manifest.transporter2Company}}</dd>
                  </div>
                  <div class="col-md-6">
                    <dt class="Allheaders">US EPA ID Number</dt>
                    <dd class="h12pt" id="USEpaIDNumberTransporter2">
                      {{manifest.transporter2Epaid}}
                    </dd>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <dt class="Allheaders">Destination Facility Name and Site Address</dt>
                    <dd id="FacilityName" class="h11pt">{{manifest.facilityName}}</dd>
                    <dd id="FacilitiyAddress" class="h11pt">{{manifest.facilityAddress}}</dd>
                  </div>
                  <div class="col-md-6">
                    <dt class="Allheaders">US EPA ID Number</dt>
                    <dd id="USEpaIDNumber2" class="h12pt">{{manifest.facilityEpaid}}</dd>
                  </div>
                </div>
                <br />
                <span style="display: inline-block">
                  <strong class="Allheaders">Facility Phone: </strong>
                  <span id="FacilityPhone" class="h11pt">{{manifest.facilityPhone}}</span>
                </span>
                <br />
                <br />
                <div class="Allheaders">
                  <div class="card">
                    <div class="card-header">
                      <div class="row">
                        <div
                          class="col-md-1"
                          style="width: 4.166665%; flex: 0 0 4.166665%; max-width: 4.166665%"
                        >
                          <dt>Hm</dt>
                        </div>
                        <div class="col-md-6">
                          <dt>U.S Dot Description</dt>
                        </div>

                        <div
                          class="col-md-1"
                          style="
                            width: 15.2499999939%;
                            flex: 0 0 15.2499999939%;
                            max-width: 15.2499999939%;
                          "
                        >
                          <dt style="position: relative; left: 20%">Containers</dt>
                          <div class="row">
                            <div class="col-md-8">
                              <dt>No.</dt>
                            </div>
                            <div class="col-md-4">
                              <dt>Type</dt>
                            </div>
                          </div>
                        </div>

                        <div
                          class="col-md-1"
                          style="
                            width: 8.0833333301%;
                            flex: 0 0 8.0833333301%;
                            max-width: 8.0833333301%;
                          "
                        >
                          <dt>Total Quantity</dt>
                        </div>
                        <div
                          class="col-md-1"
                          style="
                            width: 4.999999998%;
                            flex: 0 0 4.999999998%;
                            max-width: 4.999999998%;
                          "
                        >
                          <dt>Unit Wt/Vol.</dt>
                        </div>
                        <div
                          class="col-md-2"
                          style="
                            width: 17.499999993%;
                            flex: 0 0 17.499999993%;
                            max-width: 17.499999993%;
                          "
                        >
                          <dt>Waste Codes</dt>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf=" pagedLines && pagedLines.length > 0">
                  <div
                    class="card"
                    *ngFor="let contItem of pagedLines[0].value.lines ;  let i = index"
                  >
                    <div class="card-body">
                      <div class="row">
                        <div
                          class="col-md-1"
                          style="width: 4.166665%; flex: 0 0 4.166665%; max-width: 4.166665%"
                        >
                          <dd [attr.id]="'ctnhm' + i" class="h1">{{contItem.hm}}</dd>
                        </div>
                        <div class="col-md-6">
                          <dd [attr.id]="'ctndot' + i" class="h2">{{contItem.dotDescription}}</dd>
                        </div>
                        <div
                          class="col-md-1"
                          style="
                            width: 15.2499999939%;
                            flex: 0 0 15.2499999939%;
                            max-width: 15.2499999939%;
                          "
                        >
                          <div class="row">
                            <div class="col-md-8">
                              <dd [attr.id]="'ctnNo' + i" class="h12pt">
                                {{contItem.containersNo}}
                              </dd>
                            </div>
                            <div class="col-md-4">
                              <dd [attr.id]="'ctnType' + i" class="h12pt">
                                {{contItem.containerType}}
                              </dd>
                            </div>
                          </div>
                        </div>
                        <div
                          class="col-md-1"
                          style="
                            width: 8.0833333301%;
                            flex: 0 0 8.0833333301%;
                            max-width: 8.0833333301%;
                          "
                        >
                          <dd [attr.id]="'ctnqty' + i" class="h12pt">{{contItem.totalQuantity}}</dd>
                        </div>
                        <div
                          class="col-md-1"
                          style="
                            width: 4.999999998%;
                            flex: 0 0 4.999999998%;
                            max-width: 4.999999998%;
                          "
                        >
                          <dd [attr.id]="'ctnvol' + i" class="h12pt">{{contItem.weightUnits}}</dd>
                        </div>
                        <div
                          class="col-md-2"
                          style="
                            width: 17.499999993%;
                            flex: 0 0 17.499999993%;
                            max-width: 17.499999993%;
                          "
                        >
                          <dd class="WasteCodes">
                            <span [attr.id]="'ctnwc1' + i" class="h1">
                              {{contItem.stateWasteCode}}</span
                            >
                            <span [attr.id]="'ctnwc2' + i" class="h1">
                              {{contItem.wasteCode01}}
                            </span>
                            <span [attr.id]="'ctnwc3' + i" class="h1">
                              {{contItem.wasteCode02}}</span
                            >
                            <span [attr.id]="'ctnwc4' + i" class="h1">
                              {{contItem.wasteCode03}}
                            </span>
                            <span [attr.id]="'ctnwc5' + i" class="h1">
                              {{contItem.wasteCode04}}</span
                            >
                            <span [attr.id]="'ctnwc6' + i" class="h1">
                              {{contItem.wasteCode05}}</span
                            >
                          </dd>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <dt class="Allheaders">
                        Special Handling Instructions and Additional Information
                      </dt>
                      <dd id="handlingInstructions" style="white-space: pre-wrap" class="hs">
                        {{pagedLines[0].value.hs}}
                      </dd>
                    </div>
                  </div>
                  <div *ngFor="let pageIndex of counter(pagedLines.length - 1)">
                    <div
                      *ngIf="RestOfManifest"
                      style="position: relative; top: 0.01in; page-break-before: always"
                    >
                      <div class="pagebreak">
                        <hr />
                        <div class="row">
                          <div class="col-md-12">
                            <dt class="Allheaders">PAGE #{{pageIndex+1}}</dt>
                          </div>
                        </div>
                        <div class="h12pt" id="generatorId2">{{manifest.generatorId}}</div>
                        <div class="h12pt" id="pageNumber2">
                          {{pageIndex+1}}/{{manifest.totalPages}}
                        </div>
                        <div class="h12pt" id="shippingnumber2">{{manifest.trackingNumber}}</div>
                        <div id="generatorNameCompany" class="h1">
                          {{manifest.generatorCompany}}
                        </div>

                        <div
                          *ngFor="let contItem of pagedLines[pageIndex].value.lines; let i = index;"
                        >
                          <div class="row">
                            <div
                              class="col-md-1"
                              style="width: 4.166665%; flex: 0 0 4.166665%; max-width: 4.166665%"
                            >
                              <dd [attr.id]="'ctnhm2' + i" class="h1">{{contItem.hm}}</dd>
                            </div>
                            <div class="col-md-6">
                              <dd [attr.id]="'ctndot2' + i" class="h2">
                                {{contItem.dotDescription}}
                              </dd>
                            </div>
                            <div
                              class="col-md-1"
                              style="
                                width: 15.2499999939%;
                                flex: 0 0 15.2499999939%;
                                max-width: 15.2499999939%;
                              "
                            >
                              <div class="row">
                                <div class="col-md-8">
                                  <dd [attr.id]="'ctnNo2' + i" class="h12pt">
                                    {{contItem.containersNo}}
                                  </dd>
                                </div>
                                <div class="col-md-4">
                                  <dd [attr.id]="'ctnType2' + i" class="h12pt">
                                    {{contItem.containerType}}
                                  </dd>
                                </div>
                              </div>
                            </div>
                            <div
                              class="col-md-1"
                              style="
                                width: 8.0833333301%;
                                flex: 0 0 8.0833333301%;
                                max-width: 8.0833333301%;
                              "
                            >
                              <dd [attr.id]="'ctnqty2' + i" class="h12pt">
                                {{contItem.totalQuantity}}
                              </dd>
                            </div>
                            <div
                              class="col-md-1"
                              style="
                                width: 4.999999998%;
                                flex: 0 0 4.999999998%;
                                max-width: 4.999999998%;
                              "
                            >
                              <dd [attr.id]="'ctnvol2' + i" class="h12pt">
                                {{contItem.weightUnits}}
                              </dd>
                            </div>
                            <div
                              class="col-md-2"
                              style="
                                width: 17.499999993%;
                                flex: 0 0 17.499999993%;
                                max-width: 17.499999993%;
                              "
                            >
                              <dd class="WasteCodes">
                                <span [attr.id]="'ctnwc1-2' + i" class="h1">
                                  {{contItem.stateWasteCode}}</span
                                >
                                <span [attr.id]="'ctnwc2-2' + i" class="h1">
                                  {{contItem.wasteCode01}}
                                </span>
                                <span [attr.id]="'ctnwc3-2' + i" class="h1">
                                  {{contItem.wasteCode02}}</span
                                >
                                <span [attr.id]="'ctnwc4-2' + i" class="h1">
                                  {{contItem.wasteCode03}}
                                </span>
                                <span [attr.id]="'ctnwc5-2' + i" class="h1">
                                  {{contItem.wasteCode04}}</span
                                >
                                <span [attr.id]="'ctnwc6-2' + i" class="h1">
                                  {{contItem.wasteCode05}}</span
                                >
                              </dd>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <dd
                              id="handlingInstructionsp2"
                              style="white-space: pre-wrap"
                              class="hs"
                            >
                              {{pagedLines[pageIndex].value.hs}}
                            </dd>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
